import { Facebook, Instagram } from "lucide-react";
import { DURMAH_SOCIAL_PROFILES } from "@/content/videoLessons";
import { trackMarketingEngagement } from "@/lib/analytics/marketingEngagement";

type Props = {
  source: string;
  compact?: boolean;
};

export default function SocialFollowLinks({ source, compact = false }: Props) {
  const sharedClass = compact
    ? "inline-flex items-center gap-2 rounded-full border border-current/20 px-3 py-2 text-xs font-bold transition hover:bg-white/10"
    : "inline-flex items-center justify-center gap-2 rounded-xl border border-slate-300 px-5 py-3 text-sm font-black text-slate-800 transition hover:border-emerald-700 hover:text-emerald-800 dark:border-white/20 dark:text-white dark:hover:border-emerald-300 dark:hover:text-emerald-300";

  return (
    <div className="flex flex-wrap gap-3" aria-label="Follow Durmah on social media">
      <a
        href={DURMAH_SOCIAL_PROFILES.instagram}
        target="_blank"
        rel="noopener noreferrer"
        className={sharedClass}
        onClick={() =>
          trackMarketingEngagement("social_profile_click", {
            platform: "instagram",
            source,
          })
        }
      >
        <Instagram className="h-4 w-4" aria-hidden="true" />
        Instagram
      </a>
      <a
        href={DURMAH_SOCIAL_PROFILES.facebook}
        target="_blank"
        rel="noopener noreferrer"
        className={sharedClass}
        onClick={() =>
          trackMarketingEngagement("social_profile_click", {
            platform: "facebook",
            source,
          })
        }
      >
        <Facebook className="h-4 w-4" aria-hidden="true" />
        Facebook
      </a>
    </div>
  );
}

